// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import styled from 'styled-components';
import FieldView from '../../utils/FieldView';
import Tag from '../../utils/Tag';

/* eslint-disable camelcase */

const StyledImageWrapper = styled.div`
  position: relative;
  margin-right: 20px;
  margin-bottom: 25px;

  img {
    width: 130px;
    cursor: pointer;
  }

  &:first-child {
    img {
      width: 270px;
    }
  }

  span {
    position: absolute;
    right: 0;
    top: -22px;
    z-index: 1;
    cursor: pointer;
  }
`;

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/prop-types
const ActivityVendorView = ({ dataSource }) => {
  const {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/prop-types
    image_cdn_url,
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/prop-types
    name,
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/prop-types
    location,
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/prop-types
    locations,
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/prop-types
    tags,
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/prop-types
    cancellation_policy,
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/prop-types
    company_shortname,
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/prop-types
    customer_prototypes,
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/prop-types
    description,
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/prop-types
    headline,
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/prop-types
    images,
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/prop-types
    is_pickup_ever_available,
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/prop-types
    pk,
  } = dataSource;
  return (
    <div className='data-box'>
      <div className='media' style={{ overflow: 'visible' }}>
        <div className='media-left'>
          <img
            alt='ActivityPhoto'
            style={{ width: '210px', height: '210px' }}
            src={image_cdn_url}
          />
        </div>
        <div className='media-body' style={{ overflow: 'visible' }}>
          <h2 className='media-heading activity-title'>
            <b>{name}</b>
          </h2>
          {/* TODO: Fix this the next time the file is edited. */}
          {/* eslint-disable-next-line react/prop-types */}
          <div className='activity-city'>{location.city}</div>
          {locations &&
            // TODO: Fix this the next time the file is edited.
            // eslint-disable-next-line react/prop-types
            locations.map(l => (
              <div
                key={l.address.postal_code}
                style={{
                  fontSize: '18px',
                  color: 'rgba(79, 79, 79, 0.8)',
                  marginTop: '8px',
                }}
              >
                <i
                  className='fas fa-map-marker-alt'
                  style={{ marginRight: '10px' }}
                />
                {l.address.street} {l.address.city} {l.address.province}{' '}
                {l.address.postal_code}
              </div>
            ))}
          {tags && (
            <FieldView
              name='Tags:'
              md={2}
              sm={4}
              xs={2}
              vmd={10}
              vsm={8}
              vxs={10}
              className='mobile-hidden'
            >
              {' '}
              {/* TODO: Fix this the next time the file is edited. */}
              {/* eslint-disable-next-line react/prop-types */}
              {tags.map(tag => (
                // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                // @ts-ignore
                <Tag key={tag.name} name={tag.name} />
              ))}
            </FieldView>
          )}
          <FieldView
            name='Cancellation Policy:'
            md={2}
            sm={4}
            xs={2}
            vmd={10}
            vsm={8}
            vxs={10}
            className='mobile-hidden'
          >
            {cancellation_policy}
          </FieldView>
          <FieldView
            name='Company Short Name:'
            md={2}
            sm={4}
            xs={2}
            vmd={10}
            vsm={8}
            vxs={10}
            className='mobile-hidden'
          >
            {company_shortname}
          </FieldView>
          <FieldView
            name='Customer Prototype:'
            md={2}
            sm={4}
            xs={2}
            vmd={10}
            vsm={8}
            vxs={10}
            className='mobile-hidden'
          >
            {/* TODO: Fix this the next time the file is edited. */}
            {/* eslint-disable-next-line react/prop-types */}
            {customer_prototypes.map(c => (
              <p key={c.pk}>{c.display_name}</p>
            ))}
          </FieldView>
          <FieldView
            name='Description:'
            md={2}
            sm={4}
            xs={2}
            vmd={10}
            vsm={8}
            vxs={10}
            className='mobile-hidden'
          >
            {description}
          </FieldView>
          <FieldView
            name='Headline:'
            md={2}
            sm={4}
            xs={2}
            vmd={10}
            vsm={8}
            vxs={10}
            className='mobile-hidden'
          >
            {headline}
          </FieldView>
          <FieldView
            name='Is Pick up Ever Available:'
            md={2}
            sm={4}
            xs={2}
            vmd={10}
            vsm={8}
            vxs={10}
            className='mobile-hidden'
          >
            {is_pickup_ever_available ? 'Yes' : 'No'}
          </FieldView>
          <FieldView
            name='PK:'
            md={2}
            sm={4}
            xs={2}
            vmd={10}
            vsm={8}
            vxs={10}
            className='mobile-hidden'
          >
            {pk}
          </FieldView>
          <FieldView
            name='Media:'
            md={2}
            sm={4}
            xs={2}
            vmd={10}
            vsm={8}
            vxs={10}
            className='mobile-hidden'
          >
            {/* TODO: Fix this the next time the file is edited. */}
            {/* eslint-disable-next-line react/prop-types */}
            {images.map(i => (
              <StyledImageWrapper key={i.pk}>
                <img src={i.image_cdn_url} alt='img' role='presentation' />
              </StyledImageWrapper>
            ))}
          </FieldView>
        </div>
      </div>
    </div>
  );
};

export default ActivityVendorView;
